import type { Dispatch, SetStateAction } from 'react';

import { Box, Menu } from '@mui/material';

import Typography from '@/components/Typography';
import HistoryRecord from '@/features/AIChat/AskGXDrawer/ChatHistory/HistoryRecord';
import { useAppSelector } from '@/hooks/redux-hooks';

const ChatHistory = ({
  anchorEl,
  setAnchorEl
}: {
  anchorEl: HTMLElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
}) => {
  const conversations = useAppSelector(state => state.userConfig.userConfig.chatHistory).toSorted(
    (a, b) => {
      if (a.timestamp === b.timestamp) return 0;
      return new Date(a.timestamp) > new Date(b.timestamp) ? -1 : 1;
    }
  );
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      open={Boolean(anchorEl)}
      sx={{
        zIndex: 9999
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      onClose={handleClose}
    >
      <Box
        sx={{
          width: '320px'
        }}
      >
        <Typography
          sx={{
            color: 'var(--GX-Text-Disabled, #6C737A)',
            fontSize: '10px',
            ml: '8px'
          }}
        >
          CHAT HISTORY
        </Typography>
        {conversations.length === 0 ? (
          <Box
            sx={{
              height: '75px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Typography>No history yet</Typography>
          </Box>
        ) : (
          conversations.map((conversation, index) => (
            <HistoryRecord
              key={conversation.conversationId}
              conversation={conversation}
              handleClose={handleClose}
              index={index}
            />
          ))
        )}
      </Box>
    </Menu>
  );
};

export default ChatHistory;
